export default __webpack_public_path__ + "static/chanakya-3a069f1891518ebc0c4d54aa0f035513.png";